import React from 'react'
import { NavLink } from 'react-router-dom'

// Sub-navigation for the Knowledge Catalog section. Matches the aesthetic
// of the primary sidebar (pill-style NavLinks) but arranged as a horizontal
// tab bar because it lives inside the main content area.
const LINKS = [
  { to: '/catalog',                 label: 'Browse',       end: true },
  { to: '/catalog/view/tool',       label: 'Tools' },
  { to: '/catalog/view/work_type',  label: 'Work Types' },
  { to: '/catalog/view/department', label: 'Departments' },
  { to: '/catalog/view/agency',     label: 'Agencies' },
  { to: '/catalog/view/goal',       label: 'Goals' },
  { to: '/catalog/view/impact_area', label: 'Impact' },
  { to: '/catalog/matrix',          label: 'Matrix' },
  { to: '/catalog/review',          label: 'Review' },
]

export default function CatalogNav() {
  return (
    <nav className="flex flex-wrap gap-1 border-b border-slate-200 pb-2">
      {LINKS.map(({ to, label, end }) => (
        <NavLink
          key={to}
          to={to}
          end={end}
          className={({ isActive }) =>
            [
              'rounded-md px-3 py-1.5 text-sm font-medium transition-colors',
              isActive
                ? 'bg-accent-50 text-accent-700'
                : 'text-slate-600 hover:bg-slate-100 hover:text-slate-900',
            ].join(' ')
          }
        >
          {label}
        </NavLink>
      ))}
    </nav>
  )
}
